import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationInstrumentTypeSearchCriteria extends ModelBase {
    public organisationName: string = "";

    public instrumentTypeName: string = "";
}